import { render } from "./LazyPage.vue?vue&type=template&id=0903f1f4"
import script from "./LazyPage.vue?vue&type=script&lang=js"
export * from "./LazyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__